import { createBrowserRouter, type RouteObject } from "react-router-dom";
import { savePreferredLocale } from "../lib/save-preferred-locale";
import { createSetupRpcClient } from "../rpc-client";
import {
  type Auth,
  cleanupExpiredTokens,
  getMerchantServerUrl,
  initAuthFromUrl,
} from "./auth";

/**
 * Reads and strips the handoff params before the router exists. The router
 * keeps its own copy of the location, so params stripped later with
 * `history.replaceState` would come back on its next navigation. A handoff
 * link's language is saved here, like a globe pick.
 */
export function startSetupSession(routes: RouteObject[]): {
  initialAuth: Auth | undefined;
  router: ReturnType<typeof createBrowserRouter>;
} {
  cleanupExpiredTokens();
  const initialAuth = initAuthFromUrl();
  if (initialAuth?.linkLocale) {
    savePreferredLocale(
      createSetupRpcClient(getMerchantServerUrl(), initialAuth.token),
      initialAuth.linkLocale,
    );
  }
  return { initialAuth, router: createBrowserRouter(routes) };
}
